var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import VueDialog from "../../interface/IVueDialog";
import LicenseService from "../../api/LicenseService";
import Uploader from "../../common/components/uploader";
import { ETestReportType, ELicenseTypeAttr } from "../../enum/ELicense";
import { EHanldeStatus as EHandleStatus } from "../../enum/EHandleStatus";
import ArtMsglist from '../../components/alert/ArtMsglist.vue';
var LicenseAddEditDialog = (function (_super) {
    __extends(LicenseAddEditDialog, _super);
    function LicenseAddEditDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eTestReportType = ETestReportType;
        _this.eLicenseTypeAttr = ELicenseTypeAttr;
        _this.eHandleStatus = EHandleStatus;
        _this.handleStatus = EHandleStatus['Add'];
        _this.formData = {
            document_company: '',
            document_name: "",
            document_code: "",
            document_ctime: "",
            document_etime: "",
            longValid: false,
            document_warning: 30,
            document_remark: "",
            document_pic: [],
            document_type_id: '',
            is_company: 1,
            document_produce_time: '',
            bind_num: 0,
        };
        _this.longValid = false;
        _this.document_id = null;
        _this.documentTypeOptions = [];
        _this.document_pic = [];
        _this.warnDatas = [];
        _this.invalidDataPickerDisable = false;
        _this.warnInputDisable = false;
        _this.startPickOptions = _this.startData();
        _this.endPickOptions = _this.endData();
        return _this;
    }
    LicenseAddEditDialog.prototype.startData = function () {
        var that = this;
        return {
            disabledDate: function (time) {
                if (that.formData.document_etime)
                    return time.getTime() > new Date(that.formData.document_etime).getTime();
            }
        };
    };
    LicenseAddEditDialog.prototype.endData = function () {
        var that = this;
        return {
            disabledDate: function (time) {
                if (that.formData.document_ctime)
                    return time.getTime() < new Date(that.formData.document_ctime).getTime();
            }
        };
    };
    LicenseAddEditDialog.prototype.watchFormDataDocumentTypeId = function (newVal, oldVal) {
        if (newVal != oldVal) {
            var row = this.documentTypeOptions.filter(function (v) { return v.document_type_id == newVal; });
            if (row[0]) {
                row = row[0];
                this.formData.is_test_report = row.is_test_report;
                this.formData.attribute = row.attribute;
                console.log('this.formData.is_test_report:' + this.formData.is_test_report);
                console.log('this.formData.attribute:' + this.formData.attribute);
                if (this.formData.attribute == ELicenseTypeAttr['货品证照']) {
                    this.formData.is_company = 1;
                }
                if (this.formData.is_test_report == ETestReportType['检测类']) {
                    this.longValid = false;
                    this.setLongValid(false);
                }
                else {
                    this.formData.document_produce_time = '';
                }
            }
        }
    };
    LicenseAddEditDialog.prototype.created = function () {
        this.service = LicenseService.getInstance();
        this.getDocumentTypeOptions();
        this.getWarnDays();
        if (this.document_id) {
            this.handleStatus = EHandleStatus['Edit'];
            this.getDetail();
        }
        else {
            this.handleStatus = EHandleStatus['Add'];
            this.formData.document_company = this.company_name || '';
        }
        ;
    };
    LicenseAddEditDialog.prototype.mounted = function () {
    };
    LicenseAddEditDialog.prototype.getDocumentTypeOptions = function () {
        var _this = this;
        this.service.getDocumentTypeList().then(function (res) {
            if (res.data.success) {
                var data = res.data.data;
                _this.documentTypeOptions = data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    LicenseAddEditDialog.prototype.getWarnDays = function () {
        var _this = this;
        this.service.getWarnDays().then(function (res) {
            if (res.data.success) {
                _this.warnDatas = res.data.data;
            }
        });
    };
    LicenseAddEditDialog.prototype.getDetail = function () {
        var _this = this;
        var params = {
            document_id: this.document_id
        };
        this.service.getDetail(params).then(function (res) {
            if (res.data.success) {
                var data = res.data.data;
                _this.formData = Object.assign({}, data);
                _this.warnInputDisable = _this.invalidDataPickerDisable = _this.longValid = _this.formData.document_type == 1;
                _this.longValid && (_this.formData.document_etime = '');
            }
            else {
                _this.$message.error(res.data.msg);
            }
        });
    };
    LicenseAddEditDialog.prototype.dateChange = function (type) {
        if (this.formData.document_ctime && this.formData.document_etime && this.formData.document_ctime >= this.formData.document_etime) {
            this.$message.error('失效日期应大于发证日期！');
            if (type === 'ctime') {
                this.formData.document_ctime = '';
            }
            else {
                this.formData.document_etime = '';
            }
        }
    };
    LicenseAddEditDialog.prototype.setLongValid = function (val) {
        this.invalidDataPickerDisable = this.warnInputDisable = val;
    };
    LicenseAddEditDialog.prototype.close = function () {
        var _this = this;
        this.$confirm("您修改的内容尚未保存，确定要放弃这些内容吗?", "提示", {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function (res) {
            if (res) {
                _this.$closeDialog();
            }
        }).catch(function () { });
    };
    LicenseAddEditDialog.prototype.save = function () {
        var _this = this;
        this.$validator.validateScopes().then(function (res) {
            if (res) {
                var params = Object.assign({}, _this.formData);
                params.document_type = _this.longValid ? 1 : 0;
                params.document_pic = JSON.stringify(params.document_pic);
                params.document_ctime = new Date(params.document_ctime).format('yyyy-MM-dd');
                params.document_etime = _this.longValid ? '' : new Date(params.document_etime).format('yyyy-MM-dd');
                if (_this.document_id) {
                    _this.editLicense(params);
                }
                else {
                    _this.addLicense(params);
                }
            }
        });
    };
    LicenseAddEditDialog.prototype.addLicense = function (params) {
        var _this = this;
        this.service.licenseAddSave(params).then(function (res) {
            if (res.data.success) {
                if (res.data.code === 62) {
                    var instance = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data,
                        },
                    }, {
                        title: '提示',
                        width: 450,
                        height: 350,
                    }).instance;
                    instance.$on('artMsglist:ok', function (data) {
                        var confirm = res.data.data[0].confirm;
                        _this.addLicense(__assign({}, params, { confirm: confirm }));
                    });
                    return;
                }
                _this.$message.success('添加成功！');
                _this.$emit('add_liscense:ok');
                _this.$closeDialog();
            }
            else {
                _this.$message.error(res.data.msg);
            }
        });
    };
    LicenseAddEditDialog.prototype.editLicense = function (params) {
        var _this = this;
        this.service.editLicense(params).then(function (res) {
            if (res.data.success) {
                if (res.data.code === 62) {
                    var instance = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data,
                        },
                    }, {
                        title: '提示',
                        width: 450,
                        height: 350,
                    }).instance;
                    instance.$on('artMsglist:ok', function (data) {
                        var confirm = res.data.data[0].confirm;
                        _this.editLicense(__assign({}, params, { confirm: confirm }));
                    });
                    return;
                }
                _this.$message.success('编辑成功！');
                _this.$emit('edit_liscense:ok');
                _this.$closeDialog();
            }
            else {
                _this.$message.error(res.data.msg);
            }
        });
    };
    LicenseAddEditDialog.prototype.remarkKeyUp = function () {
        if (this.formData.document_remark.length > 50) {
            this.formData.document_remark = this.formData.document_remark.substring(0, 50);
        }
        ;
    };
    __decorate([
        Watch('formData.document_type_id')
    ], LicenseAddEditDialog.prototype, "watchFormDataDocumentTypeId", null);
    LicenseAddEditDialog = __decorate([
        Component({
            components: {
                uploader: Uploader
            }
        })
    ], LicenseAddEditDialog);
    return LicenseAddEditDialog;
}(VueDialog));
export default LicenseAddEditDialog;
